import { axiosInstance } from '../config';
import { getUserSession, getHeaders } from '../authentication';

export const getProductTypes = () => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('catalogTypeProducts/list',config);
};
